import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaTag, FaBars, FaTimes } from "react-icons/fa";
import ModalForm from "./ModalForm";
import logo from "../assets/logo.png";

const Header = () => {
  const [showModal, setShowModal] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);
  const handleCloseModal = () => setShowModal(false);

  return (
    <>
      <header className="bg-white shadow-md py-3 relative z-50">
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between">
          {/* Левая часть: логотип + навигация */}
          <div className="flex items-center gap-8">
            <Link to="/" className="flex items-center">
              <img
                src={logo}
                alt="Металл Иваныч"
                className="h-16 w-auto object-contain"
              />
            </Link>
            <nav className="hidden md:flex gap-6 text-sm font-medium text-gray-700">
              <Link to="/catalog" className="flex items-center gap-1 hover:text-red-600">
                Каталог <FaTag className="text-red-600 text-xs" />
              </Link>
              <Link to="/contacts" className="flex items-center gap-1 hover:text-red-600">
                Контакты
              </Link>
              <Link to="/about" className="flex items-center gap-1 hover:text-red-600">
                О нас
              </Link>
              <Link to="/delivery-payment" className="flex items-center gap-1 hover:text-red-600">
                Доставка
              </Link>
              <Link to="/testimonials" className="flex items-center gap-1 hover:text-red-600">
                Отзывы
              </Link>
            </nav>
          </div>

          {/* Правая часть: контакты + кнопка */}
          <div className="hidden md:flex items-center gap-6">
            <div className="text-sm text-gray-600 text-right">
              <div>
                <a href="tel:+79671602266" className="hover:text-red-600">+7 (967) 160-22-66</a>
              </div>
              <div>
                <a href="mailto:serejazork@gmail.com" className="hover:text-red-600">serejazork@gmail.com</a>
              </div>
            </div>
            <button
              onClick={() => setShowModal(true)}
              className="bg-red-600 hover:bg-red-700 text-white px-4 py-2.5 rounded text-sm shadow"
            >
              Заказать звонок
            </button>
          </div>

          {/* Мобильная кнопка */}
          <div className="md:hidden">
            <button
              onClick={toggleMobileMenu}
              className="text-red-600 text-2xl"
              style={{
                WebkitTapHighlightColor: "transparent",
                userSelect: "none",
                touchAction: "manipulation",
                outline: "none",
                backgroundColor: "transparent",
                border: "none",
                transition: "none",
              }}
              onMouseDown={(e) => e.preventDefault()}
            >
              {mobileMenuOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>

        {/* Мобильное меню */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white px-4 pb-4 pt-2 shadow-lg flex flex-col gap-3 text-sm text-gray-700 font-medium items-center text-center">
            <Link to="/catalog" onClick={toggleMobileMenu} className="flex items-center gap-1 hover:text-red-600">
              Каталог <FaTag className="text-red-600 text-xs" />
            </Link>
            <Link to="/contacts" onClick={toggleMobileMenu} className="flex items-center gap-1 hover:text-red-600">
              Контакты
            </Link>
            <Link to="/about" onClick={toggleMobileMenu} className="flex items-center gap-1 hover:text-red-600">
              О нас
            </Link>
            <Link to="/delivery-payment" onClick={toggleMobileMenu} className="flex items-center gap-1 hover:text-red-600">
              Доставка
            </Link>
            <Link to="/testimonials" onClick={toggleMobileMenu} className="flex items-center gap-1 hover:text-red-600">
              Отзывы
            </Link>

            <div className="border-t pt-3 text-sm text-gray-600 w-full flex flex-col items-center">
              <a href="tel:+79671602266" className="block hover:text-red-600">+7 (967) 160-22-66</a>
              <a href="mailto:serejazork@gmail.com" className="block hover:text-red-600">serejazork@gmail.com</a>
              <button
                onClick={() => {
                  toggleMobileMenu();
                  setShowModal(true);
                }}
                className="mt-2 w-full bg-red-600 hover:bg-red-700 text-white px-4 py-2.5 rounded text-sm max-w-xs"
              >
                Заказать звонок
              </button>
            </div>
          </div>
        )}
      </header>

      {showModal && <ModalForm onClose={handleCloseModal} />}
    </>
  );
};

export default Header;
